export const MediaSmallMobile = 576
export const MediaMobile = 768
export const MediaTablet = 992
export const MediaDesktop = 1400


export const MediaHeightExtraLarge = 700
export const MediaHeightLarge = 620
export const MediaHeightMedium = 560
export const MediaHeightRegular =510
export const MediaHeightSmall =420
export const MediaHeightExtraSmall =360